import axios from 'axios'

export async function submitApplicationRequest(payload) {
  const response = await axios.post('/api/requests/', payload, {
    headers: { 'Content-Type': 'application/json' },
  })

  return response.data
}
